import { getData } from "../../app/utils/api";
import { useEffect, useRef, useState } from "react";
import Form from "../Form";
import "./index.scss";
import cn from "classnames";

const Contacts = ({ contactMenu, security }: any) => {
  const contactsRef = useRef({});
  const [formData, setFormData] = useState(null);
  const [activeContactItem, setActiveContactItem] = useState<string | null>(
    null
  );
  const [errorMessage, setErrorMessage] = useState("");

  const requestHandler = async ({ url, form = {} }: any) => {
    setErrorMessage("");
    setFormData(null);
    try {
      const req = await getData({
        url,
        method: "POST",
        data: { ...form, security },
      });
      setFormData(req);
    } catch (e) {
      setFormData(null);
      setErrorMessage("Неопознанная ошибка. Обратитесь к менеджеру.");
    }
  };

  useEffect(() => {
    requestHandler({ url: contactMenu[0].url });
    setActiveContactItem(contactMenu[0].title);
  }, []);

  const handleSubmit = async ({ url, form }: any) => {
    requestHandler({ url, form });
  };

  return (
    <div className="contacts">
      <div className="contacts__container">
        {contactMenu.map(({ url, title }: any) => (
          <div
            className={cn("contact", {
              contact_active: title === activeContactItem && formData,
            })}
            onTransitionEnd={() => {
              if (title === activeContactItem) {
                //@ts-ignore
                contactsRef.current[title].scrollIntoView({
                  behavior: "smooth",
                });
              }
            }}
            key={url}
          >
            <div
              className="contact__container"
              ref={(ref) => {
                //@ts-ignore
                contactsRef.current[title] = ref;
              }}
            >
              <div
                className="contact__header"
                onClick={() => {
                  requestHandler({ url });
                  setActiveContactItem(title);
                }}
              >
                <span className="contact__title">{title}</span>
              </div>
              <div className="contact__wrapper">
                <div className="contact__content">
                  {title === activeContactItem && formData && (
                    <Form
                      key={activeContactItem}
                      data={formData as any}
                      onSubmit={handleSubmit}
                      onBack={() => {}}
                    />
                  )}
                  {errorMessage && <h4>{errorMessage}</h4>}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contacts;
